import { css } from '@emotion/react';
import type { AuditChange } from '@frontend/api-phone-audits';
import { useTranslation } from '@frontend/i18n';
import { Text } from '@frontend/design-system';

type EventChangesDrawerProps = {
  changes: AuditChange[];
};

/**
 * Expandable drawer section rendered inside an EventCard when the user expands an update event.
 * Displays each change entry in a grey inset container (with rounded corners, inside the card
 * padding).
 */
export const EventChangesDrawer = ({ changes }: EventChangesDrawerProps) => {
  const { t } = useTranslation('phone');

  return (
    <div
      css={css`
        background-color: var(--fabric-color-surface-inset-default);
        border-radius: var(--fabric-radius-md);
        padding: var(--fabric-space-padding-sm);
        margin-top: var(--fabric-space-gap-xs);
        display: flex;
        flex-direction: column;
        gap: var(--fabric-space-gap-xs);
      `}
    >
      {changes.map((change, index) => (
        <div key={change.type ?? index}>
          {/* TODO: Change type is used as the title for this entry for now, additional details will need to be added later */}
          <Text size='medium' weight='bold'>
            {change.type ?? t('Unknown change')}
          </Text>
        </div>
      ))}
    </div>
  );
};
